module.exports = __webpack_public_path__ + "media/images/frontend/covid19_plasma_alt-996604efae8e1eabf639afc85c142a65.svg";